import React from "react";

interface ILocationActivityTableColumnProps {
  isHeader?: boolean;
  handleSort?: (field: string) => void;
  sortField: string;
  headerText: string;
  itemText?: string;
  currentSortField?: string;
  currentSortDirection?: string;
  children?: React.ReactNode;
}

export const LocationActivityTableColumn = ({
  isHeader,
  handleSort,
  sortField,
  headerText,
  itemText,
  currentSortField,
  currentSortDirection,
  children,
}: ILocationActivityTableColumnProps) => {
  return (
    <div
      className={`${sortField}-column ${sortField}${
        isHeader ? "-header" : "-item"
      }`}
    >
      {isHeader ? (
        <button
          className="btn header-btn"
          onClick={() => handleSort && handleSort(sortField)}
        >
          <span>{headerText}</span>
          {currentSortField === sortField && currentSortDirection === "asc" && (
            <span>↑</span>
          )}
          {currentSortField === sortField &&
            currentSortDirection === "desc" && <span>↓</span>}
        </button>
      ) : (
        <>
          {itemText && <span>{itemText}</span>}
          {children && children}
        </>
      )}
    </div>
  );
};
